const initialState = {
  port: null,
  reader: null,
  weight: 0,
  error: null,
};


export const serialReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_PORT":
      return { ...state, port: action.payload };
    case "SET_READER":
      return { ...state, reader: action.payload };
    default:
      return state;
  }
};